import { initTinyMCE } from "../helper/tinymce";

document.addEventListener("DOMContentLoaded", function () {
  const editors = document.querySelectorAll(".tinymce-editor");

  if (editors.length > 0) {
    // Liefert die Seite (aus EnumBuchungPlatzhalter); ohne Liste bleibt der Editor unverändert
    initTinyMCE(".tinymce-editor", { platzhalter: window.buchungPlatzhalter || [] });
  }

  // Search functionality
  const searchInput = document.getElementById("templateSearch");
  const templateCards = document.querySelectorAll(".template-card");

  if (searchInput) {
    searchInput.addEventListener("keyup", function (e) {
      const term = e.target.value.toLowerCase();
      templateCards.forEach((card) => {
        const subject = card.querySelector(".template-subject").textContent.toLowerCase();
        const content = card.querySelector(".template-content-raw").textContent.toLowerCase();

        if (subject.includes(term) || content.includes(term)) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    });
  }

  // Modal Preview
  const previewBtns = document.querySelectorAll(".preview-btn");
  const previewModalEl = document.getElementById("previewEmailModal");
  let previewModal;
  if (previewModalEl) {
    previewModal = bootstrap.Modal.getOrCreateInstance(previewModalEl);

    previewBtns.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const subject = this.getAttribute("data-subject");
        const card = this.closest(".template-card");
        const content = card ? card.querySelector(".template-content-raw").innerHTML : "";

        document.getElementById("previewSubject").textContent = subject;
        document.getElementById("previewContent").innerHTML = content;

        if (previewModal) previewModal.show();
      });
    });
  }

  // Delete/Trash Buttons with Swal confirmation
  const deleteBtns = document.querySelectorAll(".delete-btn");
  if (deleteBtns.length > 0) {
    deleteBtns.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        const formId = this.getAttribute("data-form-id");
        const targetForm = formId ? document.getElementById(formId) : this.closest("form");
        const isTrash = this.getAttribute("data-is-trash") === "true";

        if (!targetForm) return;

        const config = isTrash
          ? {
              title: "In den Papierkorb verschieben?",
              text: "Die Vorlage wird in den Papierkorb verschoben und kann dort jederzeit wiederhergestellt werden.",
              icon: "info",
              confirmButtonText: "Ja, in den Papierkorb!",
              confirmButtonColor: "#3b82f6",
            }
          : {
              title: "Endgültig löschen?",
              text: "Diese Vorlage wird dauerhaft entfernt und kann nicht wiederhergestellt werden!",
              icon: "warning",
              confirmButtonText: "Ja, endgültig löschen!",
              confirmButtonColor: "#e11d48",
            };

        cs.Swal.fire({
          ...config,
          showCancelButton: true,
          cancelButtonColor: "#6b7280",
          cancelButtonText: "Abbrechen",
        }).then((result) => {
          if (result.isConfirmed) {
            targetForm.submit();
          }
        });
      });
    });
  }

  // Tab Validation Handling
  // When a form is submitted and has invalid fields in hidden tabs, switch to the first invalid tab
  const forms = document.querySelectorAll("form");
  forms.forEach((form) => {
    form.addEventListener(
      "invalid",
      (e) => {
        const invalidField = e.target;
        const tabPane = invalidField.closest(".tab-pane");
        if (tabPane && !tabPane.classList.contains("show")) {
          const tabId = tabPane.id;
          const tabTrigger = document.querySelector(
            `[href="#${tabId}"], [data-bs-target="#${tabId}"]`,
          );
          if (tabTrigger) {
            const tab = bootstrap.Tab.getOrCreateInstance(tabTrigger);
            tab.show();
            // Chrome needs a little timeout to focus the element after showing the tab
            setTimeout(() => {
              invalidField.focus();
              invalidField.reportValidity();
            }, 200);
          }
        }
      },
      true,
    ); // Use capture phase to catch 'invalid' events from inputs
  });
});
